import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery,
    tagTypes: ["Users"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getAllUsers: builder.query({
            query: () => ({ url: `/users` }),
            providesTags:["Users"]
        }),
        inviteUser: builder.mutation({
            query: (id) => ({
                url: `/users/${id}/invite`,
                method: 'PUT'
            }),
            invalidatesTags: ["Users"]
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `/users/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ["Users"]
        }),
        addUser: builder.mutation({
            query: (body) => ({
                url: `/users/add/`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["Users"]
        }),
        completeInvite: builder.mutation({
            query: ({code, ...body}) => ({
                url: `/users/invite/${code}/complete`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["Users"]
        })
    }),
})

export const {
    useLazyGetAllUsersQuery,
    useInviteUserMutation,
    useDeleteUserMutation,
    useAddUserMutation,
    useCompleteInviteMutation
} = userApi
